<script setup>
import fullLogo from "@i/logo-full-white.svg";
import {computed, onMounted, onUnmounted, ref} from "vue";
import {usePage} from "@inertiajs/vue3";
import Link from "@/Components/Links/Link.vue";
import hamburger from "@i/hamburger.svg";
import close from "@i/close.svg";

defineProps({
    fullMenu: Boolean,
});

const menuItems = computed(() => usePage().props.menus.find((header) => header.name === 'main'));

const showMenu = ref(false);
const y = ref(0);

onMounted(() => {
    window.addEventListener('scroll', () => {
        y.value = window.scrollY;
    });
});

onUnmounted(() => {
    window.removeEventListener('scroll', () => {
        y.value = window.scrollY;
    });
});

const companyDetails = computed(() => usePage().props.company_details);


</script>

<template>
    <header
        :class="{
            'bg-primary/0': y < 100 && route().current('public.pages.index'),
            'bg-primary/60': y < 100,
            'bg-primary': y >= 100,
            '!bg-primary': fullMenu,
        }"
        class="fixed left-0 top-0 z-40 h-23 w-full text-white transition-colors duration-300 ease-in-out lg:h-26"
    >
        <div class="outer-container lg:pl-container lg:pr-container flex-between px-4">
            <Link href="/">
                <img
                    :src="fullLogo"
                    alt="logo"
                    class="w-30 pb-3 pt-6 lg:w-40"
                >
            </Link>
            <button
                class="relative w-8 lg:hidden"
                @click="showMenu = !showMenu"
            >
                <img
                    :class="showMenu ? 'opacity-0' : ''"
                    :src="hamburger"
                    alt="menu"
                    class="absolute left-1/2 top-1/2 w-8 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-300 ease-in-out"
                >
                <img
                    :class="showMenu ? '' : 'opacity-0'"
                    :src="close"
                    alt="menu"
                    class="absolute left-1/2 top-1/2 w-8 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-300 ease-in-out"
                >
            </button>
            <div class="hidden gap-8 lg:flex">
                <Link
                    v-for="link in menuItems?.contents"
                    :key="link.data.page_id"
                    :href="link.data.url"
                >
                    {{ link.data.title }}
                </Link>
                <Link
                    :href="'tel:' + companyDetails.phone_number"
                    external
                >
                    {{ companyDetails.phone_number }}
                </Link>
            </div>
        </div>
    </header>
    <div
        v-if="fullMenu"
        class="h-23 lg:h-26 "
    />
    <div
        :class="showMenu ? '' : '-translate-y-full'"
        class="#-translate-y-full fixed inset-0 z-30 bg-primary text-white transition-transform duration-300 ease-in-out"
    >
        <div class="flex flex-col items-center gap-8 pt-30">
            <Link
                v-for="link in menuItems?.contents"
                :key="link.data.page_id"
                :blank="link.data.new_tab"
                :href="link.data.url"
            >
                {{ link.data.title }}
            </Link>
            <Link
                :href="'tel:' + companyDetails.phone_number"
                external
            >
                {{ companyDetails.phone_number }}
            </Link>
        </div>
    </div>
</template>
